import {
  Box,
  Button,
  Grid,
  Hidden,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import Layout from "../Layout/container";
import useStyle from "./styles";
import warren from "../../images/warrenAvatar.png";
import cathie from "../../images/cathieAvatar.png";
import temasek from "../../images/temasekAvatar.png";
import blackRock from "../../images/blackRockAvatar.png";
import dimensional from "../../images/dimensionalAvatar.png";
import fidelity from "../../images/fidelityAvatar.png";
import morganStanley from "../../images/morganStanleyAvatar.png";
import renaissance from "../../images/renaissanceAvatar.png";
import saba from "../../images/sabaAvatar.png";
import vanguard from "../../images/vanguardAvatar.png";
import InsiderCard from "./InsiderCard";
import { useDispatch, useSelector } from "react-redux";
import { loading } from "../../store/actions/commonAc";
import { getUserDetailsApi } from "../../store/actions/homeAc";
import isToken from "../../helpers/token-check";
import SwiperCore, { Pagination } from "swiper";
import { useTheme } from "@material-ui/styles";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import "./style.css";
import * as actions from "../../store/actions/index";
import lockContent from "../../images/lockContent.png";
import isCordova from "../../helpers/cordova-check";
import { withRouter } from "react-router";
import Footer from "../ArkFeature/shared/ArkFooter";

function getButton(urlLink, isMembership, companyUrl, checkoutUrl) {
  if (isMembership && urlLink?.length > 0) {
    return [
      {
        buttonUrl: companyUrl,
        buttonText: "Insider Trading",
      },
      {
        buttonUrl: urlLink,
        buttonText: "Community",
      },
    ];
  } else if (isMembership && urlLink?.length <= 0) {
    return [
      {
        buttonUrl: companyUrl,
        buttonText: "Insider Trading",
      },
      {
        lock: true,
        buttonUrl: checkoutUrl,
        buttonText: "Community",
      },
    ];
  } else if (isMembership === false && urlLink?.length > 0) {
    return [
      {
        buttonUrl: companyUrl,
        buttonText: "Insider Trading",
      },
      {
        buttonUrl: urlLink,
        buttonText: "Community",
      },
    ];
  } else
    return [
      {
        buttonUrl: companyUrl,
        buttonText: "View Now",
      },
    ];
}

const contentArray = [
  {
    alias: "warren",
    image: warren,
    name: "Warren Buffett",
    intro: "Fund Manager of Berkshire Hathaway Inc",
    description: `Known as the "Oracle of Omaha," Warren
   Buffett is considered as one of the most
   successful investors of all time. Buffett runs
   Berkshire Hathaway, which owns more than
   60 companies, including insurer Geico, battery maker Duracell and restaurant chain Dairy Queen.`,
    position: "#1",
    chartName: "Top 100 money management",
    netWorth: "$295.8B",
    currency: "Networth",
    featuredNumber: "45",
    featuredName: "Companies Owned",
    button: (urlLink, isMembership) =>
      getButton(
        urlLink,
        isMembership,
        "/investor/warren/fundamental",
        "/insiders/checkout/warren"
      ),
  },
  {
    alias: "cathie",
    image: cathie,
    name: "Cathie Wood",
    intro: "CEO of Ark Invest",
    description: `Cathie Wood is an excellent stock-picker and
    founder of $60 Billion (assets) ARK Invest,
    which invests in innovations like self-driving
    cars and genomics. Cathie Wood created ARK in 2014 hoping to package active stock
    portfolios in an ETF format.`,
    position: "#1",
    chartName: "Best performing ETF 2021",
    netWorth: "$38B",
    currency: "Asset Under Managment",
    featuredNumber: "160",
    featuredName: "Companies Owned",
    button: (urlLink, isMembership) =>
      getButton(
        urlLink,
        isMembership,
        "/investor/ark/fundamental",
        "/insiders/checkout/cathie"
      ),
  },
  {
    alias: "temasek",
    image: temasek,
    name: "Temasek Holdings",
    intro: "Investment company",
    description: `Temasek is a global investment company
    headquartered in Singapore. Temasek’s global portfolio, worth $381 Billion, spans a broad spectrum of industries: financial services; telecommunications, media & technology; consumer & real estate; transportation & industrials; as well as life sciences & agri-food.`,
    position: "Top 10",
    chartName: "Among Sovereign Funds Globally",
    netWorth: "$28.7B",
    currency: "Networth",
    featuredNumber: "100",
    featuredName: "Companies owned",
    button: (urlLink, isMembership) =>
      getButton(
        urlLink,
        isMembership,
        "/investor/temasek/fundamental",
        "/insiders/checkout/temasek"
      ),
  },
  // {
  //   alias: 'blackrock',
  //   image: blackRock,
  //   name: "Blackrock Inc",
  //   intro: "",
  //   description: `BlackRock Inc is one of the world’s leading asset management firms. BlackRock is also a premier provider of risk management, investment management and provides advisory services to institutional, intermediary, and retail clients across the globe.`,
  //   position: "",
  //   chartName: "",
  //   netWorth: "",
  //   currency: "",
  //   featuredNumber: "",
  //   featuredName: "",
  //   button: (urlLink, isMembership) => getButton(urlLink, isMembership, "/investor/blackrock/fundamental", "/insiders/checkout/blackrock")
  // },
  // {
  //   alias: 'vanguard',
  //   image: vanguard,
  //   name: "Vanguard Group Inc",
  //   intro: "",
  //   description: `The Vanguard Group Inc is an American investment advisor with an estimated $7 trillion in global assets under management. It is the largest provider of mutual funds and the second-largest provider of exchange-traded funds (ETFs) in the world (only after BlackRock’s iShares). In addition, Vanguard offers other services ranging from brokerage services, variable and fixed annuities, education account to asset management and trust services.`,
  //   position: "",
  //   chartName: "",
  //   netWorth: "",
  //   currency: "",
  //   featuredNumber: "",
  //   featuredName: "",
  //   button: (urlLink, isMembership) => getButton(urlLink, isMembership, "/investor/vanguard/fundamental", "/insiders/checkout/vanguard")
  // },
  // {
  //   alias: 'renaissance',
  //   image: renaissance,
  //   name: "Renaissance Technologies LLC",
  //   intro: "",
  //   description: `Renaissance Technologies is a quantitative investment management company that trades in global financial markets. By strictly adhering to mathematical and statistical methods, Renaissance Technologies is dedicated to producing exceptional returns for its stock investors.`,
  //   position: "",
  //   chartName: "",
  //   netWorth: "",
  //   currency: "",
  //   featuredNumber: "",
  //   featuredName: "",
  //   button: (urlLink, isMembership) => getButton(urlLink, isMembership, "/investor/renaissance/fundamental", "/insiders/checkout/renaissance")
  // },
  // {
  //   alias: 'saba',
  //   image: saba,
  //   name: "Saba Capital Management, L.P",
  //   intro: "",
  //   description: `Saba Capital Management, L.P is a registered investment advisor that focussed on credit and equity relative strategies. Saba Capital Management, L.P is best known for pioneering credit relative value and capital structure trading strategies. It currently uses three core strategies: Credit Relative Value, Tail Hedge, and Closed-End Funds to manage over $1.7 billion.`,
  //   position: "",
  //   chartName: "",
  //   netWorth: "",
  //   currency: "",
  //   featuredNumber: "",
  //   featuredName: "",
  //   button: (urlLink, isMembership) => getButton(urlLink, isMembership, "/investor/saba/fundamental", "/insiders/checkout/saba")
  // },
  // {
  //   alias: 'fidelity',
  //   image: fidelity,
  //   name: "FMR LLC",
  //   intro: "",
  //   description: `FMR LLC is a multinational financial services corporation that offers investment management, brokerage, financial planning, and wealth management services. It serves individuals and institutions worldwide. FMR LLC is one of the largest asset managers in the world with $4.9 trillion in assets under management and a combined total customer asset value of $8.3 trillion.`,
  //   position: "",
  //   chartName: "",
  //   netWorth: "",
  //   currency: "",
  //   featuredNumber: "",
  //   featuredName: "",
  //   button: (urlLink, isMembership) => getButton(urlLink, isMembership, "/investor/fidelity/fundamental", "/insiders/checkout/fidelity")
  // },
  // {
  //   alias: 'morgan',
  //   image: morganStanley,
  //   name: "Morgan Stanley",
  //   intro: "",
  //   description: `Morgan Stanley is a multinational investment bank and financial services company. Morgan Stanley operates in three business segments: Wealth Management, Investment Management, and Institutional Securities.`,
  //   position: "",
  //   chartName: "",
  //   netWorth: "",
  //   currency: "",
  //   featuredNumber: "",
  //   featuredName: "",
  //   button: (urlLink, isMembership) => getButton(urlLink, isMembership, "/investor/morgan/fundamental", "/insiders/checkout/morgan")
  // },
  // {
  //   alias: 'dimensional',
  //   image: dimensional,
  //   name: "Dimensional Fund Advisors LP",
  //   intro: "",
  //   description: `Dimensional Fund Advisors LP is registered with the Securities and Exchange Commission as an investment advisor. It offers a full range of equity and fixed income strategies that have been designed to target higher than expected returns.`,
  //   position: "",
  //   chartName: "",
  //   netWorth: "",
  //   currency: "",
  //   featuredNumber: "",
  //   featuredName: "",
  //   button: (urlLink, isMembership) => getButton(urlLink, isMembership, "/investor/dimensional/fundamental", "/insiders/checkout/dimensional")
  // },
];

SwiperCore.use([Pagination]);

function InsiderMember(props) {
  const classes = useStyle();
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState(0);
  const user = useSelector((state) => state.home.user);
  const { history } = props;
  useEffect(() => {
    async function getUser() {
      try {
        dispatch(loading(true));
        dispatch(actions.getUserDetails());
      } catch (error) {
        console.log(error);
      } finally {
        dispatch(loading(false));
      }
    }
    if (isToken()) {
      getUser();
    }
  }, [window.screen.availWidth]);

  const handleClick = (url) => {
    if (isCordova()) history.push(url);
    else window.open(url, "_blank");
  };

  return (
    <>
      {isToken() ? (
        <Layout>
          <div className={classes.pageMain}>
            <Grid
              className={classes.contentContainer}
              container
              direction="column"
            >
              <Box marginBottom={2}>
                <Typography color="textPrimary" align="center" variant="h2">
                  <Box fontWeight={700}>Insiders</Box>
                </Typography>
              </Box>
              <Box marginBottom={5}>
                <Typography color="textPrimary" align="justify" variant="body1">
                  With every purchase, you will be entitled to access{" "}
                  <b>historical institutional ownership</b> trends of each
                  Insiders, get <b>up to date data and news</b> in their
                  respective portfolios while{" "}
                  <b>viewing and sorting the companies by categories</b>. In
                  addition, you will be able to gauge the historical importance
                  of company developments as we have linked{" "}
                  <b>years worth of news to price movements</b>. With{" "}
                  <b>Deep-end charts</b> you will also be able to view
                  portfolios that have been segmented by the categories.
                </Typography>
              </Box>
              <Grid
                container
                justify="center"
                justifyContent="center"
                direction="row"
              >
                <Swiper
                  initialSlide={1}
                  pagination={{
                    clickable: true,
                    horizontalClass: "pagination-container",
                    type: "bullets",
                    bulletClass: "bullet-inactive",
                    bulletActiveClass: "bullet-active",
                  }}
                  style={{ padding: "20px 7px 40px 7px" }}
                  spaceBetween={10}
                  onSlideChange={(swiper) => setActiveTab(swiper.activeIndex)}
                  centeredSlidesBounds
                  slidesPerView={1}
                  allowTouchMove={true}
                  centeredSlides
                  breakpoints={{
                    600: {
                      slidesPerView: 2,
                      centeredSlides: true,
                      spaceBetween: 20,
                      initialSlide: 0,
                      allowTouchMove: true,
                    },
                    1100: {
                      slidesPerView: 3,
                      centeredSlides: false,
                      spaceBetween: 30,
                      initialSlide: 0,
                      allowTouchMove: false,
                    },
                  }}
                >
                  {contentArray.map((content) => (
                    <SwiperSlide>
                      <InsiderCard
                        key={content.alias}
                        button={content.button(
                          user?.Insiders[content.alias]?.CommunityURL,
                          user?.Insiders[content.alias]?.Membership
                        )}
                        image={content.image}
                        intro={content.intro}
                        name={content.name}
                        description={content.description}
                        position={content.position}
                        chartName={content.chartName}
                        netWorth={content.netWorth}
                        currency={content.currency}
                        featuredNumber={content.featuredNumber}
                        featuredName={content.featuredName}
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
                <Hidden smUp>
                  <Grid
                    container
                    style={{ paddingBottom: 30 }}
                    item
                    direction="row"
                    justify="space-around"
                    justifyContent="space-around"
                  >
                    {contentArray[activeTab]
                      .button(
                        user?.Insiders[contentArray[activeTab].alias]
                          ?.CommunityURL,
                        user?.Insiders[contentArray[activeTab].alias]
                          ?.Membership
                      )
                      .map((item) => {
                        if (item.lock === true) {
                          return (
                            <Button
                              onClick={() => handleClick(item.buttonUrl)}
                              // onClick={() =>
                              //   window.open(item.buttonUrl, "_blank")
                              // }
                              variant="contained"
                              color="primary"
                              className={classes.startButton}
                            >
                              <img
                                alt="lockButton"
                                src={lockContent}
                                width="30px"
                                style={{ marginRight: 5 }}
                              ></img>
                              <Typography align="center" variant="subtitle1">
                                <Box color="white" fontWeight={700}>
                                  {item.buttonText}
                                </Box>
                              </Typography>
                            </Button>
                          );
                        } else
                          return (
                            <Button
                              onClick={() => handleClick(item.buttonUrl)}
                              // onClick={() =>
                              //   window.open(item.buttonUrl, "_blank")
                              // }
                              variant="contained"
                              color="primary"
                              className={classes.startButton}
                            >
                              {item.buttonText}
                            </Button>
                          );
                      })}
                  </Grid>
                </Hidden>
              </Grid>
            </Grid>
            <Footer />
          </div>
        </Layout>
      ) : (
        <div className={classes.pageMain}>
          <Grid
            className={classes.contentContainer}
            container
            direction="column"
          >
            <Box marginBottom={2}>
              <Typography color="textPrimary" align="center" variant="h2">
                <Box fontWeight={700}>Insiders</Box>
              </Typography>
            </Box>
            <Box marginBottom={5}>
              <Typography color="textPrimary" align="justify" variant="body1">
                With every purchase, you will be entitled to access{" "}
                <b>historical institutional ownership</b> trends of each
                Insiders, get <b>up to date data and news</b> in their
                respective portfolios while{" "}
                <b>viewing and sorting the companies by categories</b>. In
                addition, you will be able to gauge the historical importance of
                company developments as we have linked{" "}
                <b>2 years worth of news to price movements</b>. With{" "}
                <b>Deep-end charts</b> you will also be able to view portfolios
                that have been segmented by the categories.
              </Typography>
            </Box>
            <Grid
              container
              justify="center"
              justifyContent="center"
              direction="row"
            >
              <Swiper
                initialSlide={1}
                pagination={{
                  clickable: true,
                  horizontalClass: "pagination-container",
                  type: "bullets",
                  bulletClass: "bullet-inactive",
                  bulletActiveClass: "bullet-active",
                }}
                style={{ padding: "20px 7px 40px 7px" }}
                spaceBetween={10}
                onSlideChange={(swiper) => setActiveTab(swiper.activeIndex)}
                centeredSlidesBounds
                slidesPerView={1}
                centeredSlides
                breakpoints={{
                  600: {
                    slidesPerView: 2,
                    centeredSlides: true,
                    spaceBetween: 20,
                    initialSlide: 0,
                    allowTouchMove: true,
                  },
                  1100: {
                    slidesPerView: 3,
                    centeredSlides: false,
                    spaceBetween: 30,
                    initialSlide: 0,
                    allowTouchMove: false,
                  },
                }}
              >
                {contentArray.map((content) => (
                  <SwiperSlide>
                    <InsiderCard
                      key={content.alias}
                      button={content.button(
                        user?.Insiders[content.alias]?.CommunityURL,
                        user?.Insiders[content.alias]?.Membership
                      )}
                      image={content.image}
                      intro={content.intro}
                      name={content.name}
                      description={content.description}
                      position={content.position}
                      chartName={content.chartName}
                      netWorth={content.netWorth}
                      currency={content.currency}
                      featuredNumber={content.featuredNumber}
                      featuredName={content.featuredName}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
              <Hidden smUp>
                <Grid
                  container
                  style={{ paddingBottom: 30 }}
                  item
                  direction="row"
                  justify="space-around"
                  justifyContent="space-around"
                >
                  {contentArray[activeTab]
                    .button(
                      user?.Insiders[contentArray[activeTab].alias]
                        ?.CommunityURL,
                      user?.Insiders[contentArray[activeTab].alias]?.Membership
                    )
                    .map((item) => {
                      if (item.lock === true) {
                        return (
                          <Button
                            onClick={() => handleClick(item.buttonUrl)}
                            // onClick={() =>
                            //   window.open(item.buttonUrl, "_blank")
                            // }
                            variant="contained"
                            color="primary"
                            className={classes.startButton}
                          >
                            <img
                              alt="lockButton"
                              src={lockContent}
                              width="30px"
                              style={{ marginRight: 5 }}
                            ></img>
                            <Typography align="center" variant="subtitle1">
                              <Box color="white" fontWeight={700}>
                                {item.buttonText}
                              </Box>
                            </Typography>
                          </Button>
                        );
                      } else
                        return (
                          <Button
                            onClick={() => handleClick(item.buttonUrl)}
                            // onClick={() =>
                            //   window.open(item.buttonUrl, "_blank")
                            // }
                            variant="contained"
                            color="primary"
                            className={classes.startButton}
                          >
                            {item.buttonText}
                          </Button>
                        );
                    })}
                </Grid>
              </Hidden>
            </Grid>
          </Grid>
          <Footer />
        </div>
      )}
    </>
  );
}

export default withRouter(InsiderMember);
